import { Button } from '@mui/material';
import { object, shape } from 'prop-types';
import React, { Component } from 'react';
import { notifySignatureViewed } from 'components/@home/@signatures/pendingSignatures';
import Http from 'services/Http';
import { I18n } from 'utils/i18n';
import channelShape from 'shapes/channel';
import employeeShape from 'shapes/employee';
import messageShape from 'shapes/message';
import connector from './connector';

class OpenButton extends Component {
  showOpenError = error => {
    const reason = error?.payload || error;
    const text =
      reason?.data?.error?.message ||
      reason?.data?.message ||
      reason?.message ||
      I18n.t('AcknowledgementMessage.Could not open');
    this.props.actions.alert.show({
      message: String(text).replace(/^Error:\s*/, ''),
      variant: 'error',
    });
  };

  openModal = () => {
    const { actions, message, channel, employee } = this.props;
    const acknowledged =
      message?.acknowledges && message?.acknowledges.find(m => m.user === employee?.user?._id);
    if ((message.digitalSignature || message.isMandatory) && !message.form && !acknowledged) {
      Http.post(`/v1/signatures/${message._id}/viewed`).catch(() => {});
      notifySignatureViewed(message._id);
    }
    try {
      const result = message.form
        ? actions.fillFormDrawer.open({ message, channel, employee })
        : actions.acknowledgmentReadModal.open(message, channel, employee);
      Promise.resolve(result).catch(this.showOpenError);
    } catch (error) {
      this.showOpenError(error);
    }
  };

  render() {
    const { message, employee } = this.props;

    const acknowledged =
      message?.acknowledges && message?.acknowledges.find(m => m.user === employee?.user?._id);

    return (
      <Button
        variant="contained"
        color="primary"
        sx={theme => ({
          minWidth: '110px',
          fontSize: '15px',
          boxShadow: '0 1px 2px 0 rgba(2, 2, 3, 0.05)',
          borderColor: theme.palette.primary.main,
        })}
        onClick={this.openModal}
      >
        {I18n.t(`AcknowledgementMessage.${!message.form || acknowledged ? 'Open' : 'Respond'}`)}
      </Button>
    );
  }
}

OpenButton.propTypes = {
  message: messageShape.isRequired,
  employee: employeeShape.isRequired,
  channel: channelShape.isRequired,
  actions: shape({
    acknowledgmentReadModal: object.isRequired,
  }).isRequired,
};

export default connector(OpenButton);
